const isLoading = state => state.user.isLoading;
const getUserInfo = state => state.user.userInfo;

const userSelectors = {
  isLoading,
  getUserInfo,
};

export default userSelectors;
